import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EGNodeBConfigParameters = {
	NrArfcn: 'NR_arfcn',
	NrBand: 'NR_band',
	frequency: 'frequency',
} as const;

export const EGNodeBParametersTypes = {
	gnodeb: 'gnodeb',
} as const;

export const EGNodeBConfigParametersValidationTypes = {
	listOfValues: 'LIST_OF_VALUES',
	integerInterval: 'INTEGER_INTERVAL',
} as const;

export const EGNodeBConfigParametersValidationTitles = {
	listOfValues: 'List of values',
	integerInterval: 'Integer interval',
} as const;

export type TGNodeBConfigParameters = TValueOfStringRecord<typeof EGNodeBConfigParameters>
export type TGNodeBParametersTypes = TValueOfStringRecord<typeof EGNodeBParametersTypes>
export type TGNodeBConfigParametersValidationTypes = TValueOfStringRecord<typeof EGNodeBConfigParametersValidationTypes>
export type TGNodeBConfigParametersValidationTitles =
	TValueOfStringRecord<typeof EGNodeBConfigParametersValidationTitles>
